module.exports = __webpack_public_path__ + "img/kid-school.d49ad1bd.svg";